import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyCheckEdit, faBalanceScale} from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from '../architecture/frontend/index'
import DatePicker from 'react-datepicker'
import moment from 'moment'

const Settlement = (props) => {
  const showSettlement = true// props.Textbox?.moisture?.claimPercent !== ''
  return (
    <>
    {showSettlement &&
      <div className='' style={{width: 280}}>
        <div className='w-100 pa3 flex items-center' style={{background: '#4a7b60', position: 'sticky', top:0}}>
          <FontAwesomeIcon className='f5 ' icon={faBalanceScale} style={{color: '#7bb093'}}/>
          <div className='pl2 fw7 f6 white'>Settlement </div>
          {/* <div className='pl2 yellow fw6 f4 f3' style={{fontFamily: 'monospace'}}> @232322</div> */}
        </div>
        <div className='' style={{background: '#f4f9f6'}}>
          <div className='flex pv3 justify-center bb b--near-white dark-gray' style={{background: '#ebf3ee'}}>
            <div className='flex flex-column'>
              <div className='br3 w3 pa2 f6 fw5 tc ba b--moon-gray dark-gray' style={{background: '#D1DFD3'}}>{props.shipment?.settlementMoisturePercent}%</div>
              <div className='pt1 f7 tc'>Moisture</div>
            </div>
            <div className='pl2 flex flex-column'>
              <div className='br3 w3 pa2 f6 fw5 tc ba b--moon-gray dark-gray' style={{background: '#D1DFD3'}}>{props.shipment?.settlementProtein12Percent}%</div>
              <div className='pt1 f7 tc'>Protein 12%</div>
            </div>
            <div className='pl2 flex flex-column'>
              <div className='br3 w3 pa2 f6 fw5 tc ba b--moon-gray dark-gray' style={{background: '#D1DFD3'}}>{props.shipment?.settlementFiber12Percent}%</div>
              <div className='pt1 f7 tc'>Fiber 12%</div>
            </div>
          
          </div>
          <div className='bb b--near-white pv3 ph4 mh2'>
            <div className='w-100 flex items-center justify-between dark-gray'>
                <div className='fw5 f6'>Moisture:</div>
                <div className='f6'>${props.shipment?.settlementMoistureDollars && parseFloat(props.shipment.settlementMoistureDollars).toFixed(2)}</div>
              </div>
            <div className='pt1 w-100 flex items-center justify-between dark-gray'>
                <div className='fw5 f6'>Protein:</div>
                <div className='f6'>${props.shipment?.settlementProteinDollars && parseFloat(props.shipment.settlementProteinDollars).toFixed(2)}</div>
              </div>
              <div className='pt1 w-100 flex items-center justify-between dark-gray'>
                <div className='fw5 f6'>Fiber:</div>
                <div className='f6'>${props.shipment?.settlementFiberDollars && parseFloat(props.shipment.settlementFiberDollars).toFixed(2)}</div>
              </div>
              {/* <div className='pt2 w-100 flex items-center justify-between dark-gray'>
                <div className='fw6 f6'>Tons:</div>
                <div className='w3 pa2 br2 bg-white'></div>
              </div>
              <div className='pt2 w-100 flex items-center justify-between dark-gray'>
                <div className='fw6 f6'>Cost Per Ton:</div>
                <div className='w3 pa2 br2 bg-white'></div>
              </div> */}
              <div className='pt2 w-100 flex items-center justify-between dark-gray'>
                <div className='pt2 fw5 f6 fw7'>Total:</div>
                <div className='f6 fw7'>${props.shipment?.settlementTotalDollars && parseFloat(props.shipment.settlementTotalDollars).toFixed(2)}</div>
              </div>
          </div>
        </div>
        <div className='pv3 ph4 bt b--white' style={{background: '#ebf3ee'}}>
          <div className='w-100 items-center justify-between dark-gray'>
            <div className='pb1 fw7 f7'>Remarks</div>
             <input 
              className='w-100 pa2 br2 bg-white f6 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              placeholder=''
              defaultValue={props.shipment?.settlementRemarks}
              onChange={e=>Dispatch.nextAction('shipment.set', {type: 'settlementRemarks', value: e.target.value})}
            />
          </div>
        </div>
        <div className='w-100 pa3 flex items-center' style={{background: '#4a7b60'}}>
          <FontAwesomeIcon className='relative f5 ' icon={faMoneyCheckEdit} style={{top:-3, color: '#7bb093'}}/>
          <div className='pl2 fw7 f6 white '>Payment </div>

        </div>
        <div className='pv3 ph4 bt b--white' style={{background: '#ebf3ee'}}>
          <div className='w-100 items-center justify-between dark-gray'>
            <div className='fw7 f7 pb1'>Check Number</div>
             <input 
              className='w-100 pa2 br2 bg-white f6 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              placeholder=''
              defaultValue={props.shipment?.settlementCheckNumber}
              onChange={e=>Dispatch.nextAction('shipment.set', {type: 'settlementCheckNumber', value: e.target.value})}
            />
          </div>
        </div>
        <div className='pv3 ph4 bt b--white' style={{background: '#f4f9f6'}}>
          <div className='w-100 items-center justify-between dark-gray'>
            <div className='fw7 f7 pb1'>Date Sent</div>
            <div className='mt1 ba b--moon-gray bg-white'>
              <DatePicker className='w-100 pa2 f6 bn input-reset' selected={props.shipment?.settlementSentDate && new Date(props.shipment?.settlementSentDate)} onChange={e => Dispatch.nextAction('shipment.set', {type: 'settlementSentDate', value: moment(e)?.toISOString() ?? ''})} />
            </div>
          </div>
        </div>
      </div>
    }
    </>
  )
}

export default Settlement